import { useMemo } from "react";
import { theme } from "../../../theme";
import { formatMoney } from "../../../utils";

const CostStatus = ({
    ftm_to_customer_cost = 0,
    instafix_to_customer_cost = 0,
    booking_fee = 0,
    call_out_fee = 0,
    rate_per_hour = 0,
    working_hours = 0
}) => {

    const costItems = useMemo(() => ([
        {
            title: "Tradesperson to customer",
            description: "Amount paid directly to the tradesperson for the job",
            value: formatMoney(ftm_to_customer_cost)
        },
        {
            title: "Instafix to customer",
            description: "Platform service charge billed to the customer",
            value: formatMoney(instafix_to_customer_cost)
        },
        {
            title: "Booking fee",
            description: "One-time fee for confirming and scheduling the job",
            value: formatMoney(booking_fee)
        },
        {
            title: "Call-out fee",
            description: "Charge for the tradesperson’s visit to the location",
            value: formatMoney(call_out_fee)
        },
        {
            title: "Hourly rate",
            description: "Amount charged for each hour of active work performed",
            value: formatMoney(rate_per_hour)
        },
        {
            title: "Working time",
            description: "Total duration spent completing tasks at the job site",
            value: `${working_hours} ${working_hours === 1 ? "hour" : "hours"}`
        }
    ]), [
        ftm_to_customer_cost,
        instafix_to_customer_cost,
        booking_fee,
        call_out_fee,
        rate_per_hour,
        working_hours
    ]);

    return (
        <div className="row mt-4">
            {costItems.map(({ title, description, value }, index) => (
                <div className="col-md-2 col-sm-6 col-6" key={index}>
                    <div className="card h-100">
                        <div className="card-body text-center">
                            <h2 className={`text-gradient text-${theme.main}`}>
                                {value}
                            </h2>
                            <h6 className="mb-0 font-weight-bolder">
                                {title}
                            </h6>
                            <p className="opacity-8 mb-0 text-sm">
                                {description}
                            </p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default CostStatus;